import { asyncActionCreator } from '../../global/redux';
import * as constants from './constants';

export const getSavedListProfilesDataAction = asyncActionCreator(
  constants.GET_SAVED_LIST_PROFILES_DATA,
);
export const deleteSavedListProfileAction = asyncActionCreator(constants.DELETE_SAVED_LIST_PROFILE);
